import { useAuth, UserPermission } from '@services/auth'
import envStore from '@shared/env'
import * as Icons from '@shared/icons'
import {
  always,
  ifElse,
  isNil,
  join,
  length,
  map,
  not,
  path,
  pathOr,
  split,
} from 'ramda'
import React from 'react'
const { compose } = require('ramda')

export type RouteItem = {
  id: number
  title: string
  path: string
  component: typeof React.Component
  icon?: React.FunctionComponent
  disabled?: boolean
  param?: string
  children?: RouteItem[]
  hide?: RouteItem[]
  creatable?: boolean
  updatable?: boolean
  deletable?: boolean
  readable?: boolean
  isSubMenu: boolean
  code: string
  mainKey: string
  subKey: string
  parentName?: string
  isHideOnMenu?: boolean
  url: string
}

export interface Route extends RouteItem {
  children: Array<RouteItem>
  hide: Array<RouteItem>
  disabled: boolean
}

let setting = {
  creatable: true,
  deletable: true,
  isSubMenu: true,
  readable: true,
  updatable: true,
}

export function usePrepareRoutes() {
  // console.log('NODE_ENV',process.env.NODE_ENV);
  const isStaging = process.env.REACT_APP_IS_STAGING || false

  const { user } = useAuth()
  let _user = {
    ...user,
    funcList: [
      ...pathOr([], ['funcList'], user),
      (isStaging || envStore.isEnvDev) && {
        icon: 'IconSetting',
        id: 99999,
        isSub: true,
        isSubMenu: true,
        mainKey: '測試',
        memberRoleSeq: 1,
        name: '測試',
        children: [
          {
            ...setting,
            code: 'repair_query',
            icon: 'IconSetting',
            id: 99998,
            isSubMenu: false,
            mainKey: 'testManagement',
            name: '訂單測試頁面',
            parentId: 90,
            parentName: '未加入菜單的頁面',
            subKey: 'order test',
            url: '/order-test-page',
          },
        ],
      },
      // {
      //   icon: 'IconSetting',
      //   id: 92,
      //   isSub: true,
      //   isSubMenu: true,
      //   mainKey: '未加入菜單的頁面',
      //   memberRoleSeq: 1,
      //   name: '未加入菜單的頁面',
      //   children: [
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 26,
      //       isSubMenu: false,
      //       mainKey: 'reportSetting',
      //       name: '停車統計報表',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/report/parking',
      //     },
      //   ],
      // },

      // {
      //   icon: 'IconSetting',
      //   id: 92,
      //   isSub: true,
      //   isSubMenu: true,
      //   mainKey: '營運設定',
      //   memberRoleSeq: 1,
      //   name: '營運設定',
      //   children: [
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 26,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: '充電樁基本費率',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/charging-base-rate-management',
      //     },

      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 27,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: '充電樁優惠費率',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/charging-discount-rate-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 28,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: '車格占用費設定',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/car-space-occupancy-fee-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 29,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: '停車費基本費率',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/parking-base-rate-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 30,
      //       isSubMenu: false,
      //       mainKey: 'opevrationsSetting',
      //       name: '停車費優惠費率',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/parking-discount-rate-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 31,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: 'App任務獎勵',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/app-mission-reward-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 32,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: 'App序號管理',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/app-reward-point-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 33,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: '訂單管理',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/order-management',
      //     },
      //     {
      //       ...setting,
      //       code: 'repair_query',
      //       icon: 'IconSetting',
      //       id: 34,
      //       isSubMenu: false,
      //       mainKey: 'operationsSetting',
      //       name: '充電服務報表',
      //       parentId: 90,
      //       parentName: '未加入菜單的頁面',
      //       subKey: 'repair inquiry',
      //       url: '/report/charge-service',
      //     },
      //   ],
      // },
    ],
  }

  return (routes: { [key: string]: any }) => {
    // const __getHide = (path: any, component: any) => {
    //   const hide = pathOr({}, ['hideList', path], _user)
    //   return isEmpty(hide) ? [] : [{ ...hide, path, component }]
    // }

    const __getComponent = (p: any) => {
      return path([
        compose(
          join(''),
          map((s: string) => s.charAt(0).toUpperCase() + s.slice(1)),
          split('-'),
          ifElse(v => length(v) === 3, pathOr('', [2]), pathOr('', [1])),
          split('/')
        )(p),
      ])(routes)
    }

    const funcList = compose(
      map((x: UserPermission) => ({
        ...x,
        title: x.name,
        path: x.url,
        icon: ifElse(
          compose(not, isNil, path([x.icon])),
          () => (Icons as any)[x.icon],
          always(null)
        )(Icons),
        ...(x.isSubMenu
          ? {}
          : {
              component: __getComponent(pathOr('', ['url'], x)),
              // hide: __getHide(
              //   pathOr('', ['url'], x),
              //   __getComponent(pathOr('', ['url'], x))
              // ),
            }),
        children: compose(
          map((c: UserPermission) => {
            const component = __getComponent(pathOr('', ['url'], c))
            return {
              ...c,
              id: `${c.code}_${c.id}`,
              title: c.name,
              path: c.url,
              component,
              // hide: __getHide(c.url, component),
              isHideOnMenu: c.url ? true : false,
            }
          }),
          pathOr([], ['children'])
        )(x),
      })),
      pathOr([], ['funcList'])
    )(_user)

    return funcList
  }
}

export default usePrepareRoutes
